<div *ngIf="data?.title" class="table-widget-title">
  <label>{{ data?.title }}</label>
</div>

<div
  class="card table-wrapper"
  [class.table-wrapper--paginated]="data?.isPagination"
  [class.quote-details-table]="widgetId === 'quotePartsTable'"
>
  <div class="table-spinner-overlay" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>



  <div [ngClass]="!data?.isPagination ? 'table-container' : ''">
    <table mat-table [dataSource]="data?.isPagination ? pagedData : dataSource">
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th
          class="tableheader"
          [ngClass]="getHeaderClasses(column)"
          [style.width.px]="getFixedColumnWidth(column)"
          [style.minWidth.px]="getFixedColumnWidth(column)"
          [style.maxWidth.px]="getFixedColumnWidth(column)"
          mat-header-cell
          *matHeaderCellDef
        >
          {{ formatHeaderLabel(columnLabels[column]) }}
        </th>
        <td
          class="tablebody"
          [ngClass]="getCellClasses(column, row)"
          [style.width.px]="getFixedColumnWidth(column)"
          [style.minWidth.px]="getFixedColumnWidth(column)"
          [style.maxWidth.px]="getFixedColumnWidth(column)"
          mat-cell
          *matCellDef="let row"
        >
          <ng-container *ngIf="isDropdownColumn(column); else textCell">
            <mat-form-field
              appearance="outline"
              class="table-cell-dropdown"
              [class.fixed-discount-dropdown]="isFixedDiscountColumn(column)"
              [class.compact-dropdown]="isCompactColumn(column)"
              [class.numeric-dropdown]="isNumericColumn(column, row)"
            >
              <mat-select
                [(ngModel)]="row[column]"
                [ngModelOptions]="{ standalone: true }"
                [placeholder]="getDropdownPlaceholder(column)"
                (selectionChange)="onDropdownValueChange(row, column, $event.value)"
              >
                <mat-option *ngFor="let option of getDropdownOptions(column)" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-template #textCell>
            <span
              [class.item-id-no-wrap]="column === 'item_id'"
              [title]="column === 'item_id' ? row[column] : null"
            >
              {{ row[column] }}
            </span>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;">
      </tr>

    </table>
  </div>

  <div class="table-footer-actions" *ngIf="tableActions.length > 0 && !areActionsOutsideTable">
    <button
      *ngFor="let action of tableActions"
      mat-raised-button
      class="table-action-button"
      [disabled]="isActionLoading"
      (click)="onTableActionClick(action)"
    >
      {{ action.label || action.label_name || 'Action' }}
    </button>
  </div>
</div>

<div
  class="table-footer-actions table-footer-actions--outside"
  [class.quote-parts-outside-actions]="widgetId === 'quotePartsTable'"
  *ngIf="tableActions.length > 0 && areActionsOutsideTable"
>
  <button
    *ngFor="let action of tableActions"
    mat-raised-button
    class="table-action-button"
    [disabled]="isActionLoading"
    (click)="onTableActionClick(action)"
  >
    {{ action.label || action.label_name || 'Action' }}
  </button>
</div>
